import React, { useState } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { Dialog } from '@rneui/themed';
import { LocalizedString, Color, FontFamily, FontSize, Padding } from '@common';

const DeleteProfileModal = ({
  visible,
  onClose,
  onConfirmDelete,
  isLoading
}) => {
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');
  const [password, setPassword] = useState('');

  const handleClose = () => {
    setStep(1);
    setConfirmText('');
    setPassword('');
    onClose();
  };

  const handleReady = () => {
    setStep(2);
  };

  const handleConfirm = () => {
    if (confirmText.toUpperCase() !== 'DELETE') {
      alert(LocalizedString.invalidDeleteConfirmation);
      return;
    }
    if (!password) {
      alert(LocalizedString.pleaseEnterPassword);
      return;
    }
    onConfirmDelete(password);
    setStep(1);
    setConfirmText('');
    setPassword('');
  };

  if (isLoading) {
    return (
      <Dialog isVisible={visible}>
        <Dialog.Loading />
      </Dialog>
    );
  }

  return (
    <Dialog
      isVisible={visible}
      onBackdropPress={handleClose}
    >
      <Dialog.Title title={LocalizedString.deleteProfile} />

      {step === 1 ? (
        <>
          <Text style={styles.warningText}>
            {LocalizedString.deleteProfileWarning}
          </Text>
          <Dialog.Actions>
            <Dialog.Button
              title={LocalizedString.readyToDelete}
              onPress={handleReady}
              titleStyle={styles.dangerButton}
            />
            <Dialog.Button
              title={LocalizedString.cancel}
              onPress={handleClose}
            />
          </Dialog.Actions>
        </>
      ) : (
        <>
          <Text style={styles.confirmLabel}>
            {LocalizedString.typeDeleteToConfirm}
          </Text>
          <TextInput
            style={styles.textInput}
            placeholder={LocalizedString.deleteConfirmationPlaceholder}
            value={confirmText}
            onChangeText={setConfirmText}
            autoCapitalize="characters"
            autoCorrect={false}
          />
          <Text style={styles.confirmLabel}>
            {LocalizedString.enterPasswordToConfirm}
          </Text>
          <TextInput
            style={styles.textInput}
            placeholder={LocalizedString.password}
            value={password}
            onChangeText={setPassword}
            secureTextEntry={true}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Dialog.Actions>
            <Dialog.Button
              title={LocalizedString.confirm}
              onPress={handleConfirm}
              titleStyle={styles.dangerButton}
            />
            <Dialog.Button
              title={LocalizedString.cancel}
              onPress={handleClose}
            />
          </Dialog.Actions>
        </>
      )}
    </Dialog>
  );
};

const styles = StyleSheet.create({
  warningText: {
    fontSize: FontSize.size_base,
    fontFamily: FontFamily.interRegular,
    color: Color.gray01,
    lineHeight: 22,
    marginBottom: Padding.p_base,
  },
  confirmLabel: {
    fontSize: FontSize.size_base,
    fontFamily: FontFamily.interMedium,
    fontWeight: '500',
    color: Color.black,
    marginBottom: Padding.p_xs,
  },
  textInput: {
    borderWidth: 1,
    borderColor: Color.gray_200,
    borderRadius: 8,
    padding: Padding.p_xs,
    fontSize: FontSize.size_base,
    fontFamily: FontFamily.interRegular,
    marginBottom: Padding.p_base,
  },
  dangerButton: {
    color: '#DC3545',
  },
});

export default DeleteProfileModal;
